import React from 'react'

const Tag = ({ children }) => (
  <span className="p-0.5 px-2 font-semibold uppercase tracking-wider bg-gray-100 shadow-md rounded-md">
    {children}
  </span>
)

export default Tag
